import clsx from 'clsx'
import { RateStatus } from 'lib/graphql/storeadmin'
import { Button, Card, Form, Paragraph, Select, Title } from 'components/common'

export interface RateStatusProps {
  status?: RateStatus
  loading?: boolean
  onUnarchive?: () => void
}

export interface StatusFormValue {
  status?: RateStatus
}

export const RateStatusSelect = ({
  status = RateStatus.Active,
  loading = false,
  onUnarchive,
}: RateStatusProps) => {
  return (
    <>
      <Card shadow loading={loading}>
        <Title level={5}>ステータス</Title>

        {status !== 'ARCHIVED' && (
          <Form.Item noStyle shouldUpdate>
            {() => (
              <Form.Item
                name="status"
                initialValue={status}
                rules={[
                  {
                    required: true,
                    message: 'ステータスは必須です。',
                  },
                ]}
                noStyle
              >
                <Select style={{ width: '100%' }}>
                  <Select.Option value={RateStatus.Active}>
                    アクティブ
                  </Select.Option>
                  <Select.Option value={RateStatus.Inactive}>
                    非アクティブ
                  </Select.Option>
                </Select>
              </Form.Item>
            )}
          </Form.Item>
        )}

        {status === 'ARCHIVED' && (
          <div className={clsx('rounded-lg', 'bg-gray-100', 'p-8')}>
            <div
              className={clsx(
                'flex',
                'flex-col',
                'flex-center',
                'items-center'
              )}
            >
              <Paragraph className={clsx('text-2xl')} strong>
                アーカイブ済み
              </Paragraph>
              <Paragraph>
                管理画面の料金テーブル一覧にのみ表示されます。それ以外では非表示です。
              </Paragraph>
              <Button onClick={onUnarchive}>アーカイブを解除する</Button>
            </div>
          </div>
        )}
      </Card>
    </>
  )
}
